import { PaymentMethod } from '@openeducation/pp-rn-shared-types';

export const getPendingPaymentMethod = (
  isPayPalRedirectionFlow: boolean,
  isPayU: boolean,
  isYuno: boolean,
  isTwoCreditCards: boolean = false
) => {
  if (isPayPalRedirectionFlow) {
    return PaymentMethod.PAY_PAL;
  }
  if (isPayU || isYuno) {
    return PaymentMethod.ALTERNATIVE;
  }
  if (isTwoCreditCards) {
    return PaymentMethod.TWO_CREDIT_CARDS;
  }

  return PaymentMethod.CREDIT_CARD;
};
